import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormGroup } from 'reactstrap';
import SubCategorySelect from '../../comps/SubCategorySelect';

function QuestionnaireCard(props) {
  const { intrests = null } = props;
  const [selectedBrands, setSelectedBrands] = useState(null);
  const [brandChecked, setBrandChecked] = useState(false);
  const {
    icon, heading, tagLine, brands, brandsChangeCallback,
  } = props;

  useEffect(() => {
    setSelectedBrands(intrests);
    brands && brandsChangeCallback(intrests || null, brands._id, brands.name);
  }, [props]);

  useEffect(() => {
    if (selectedBrands && setBrandChecked.length > 0) {
      setBrandChecked(true);
    }

    if (brands) {
      const selBrands = brandChecked && !selectedBrands ? [] : selectedBrands;
      brandsChangeCallback(selBrands, brands._id, brands.name);
    }
  }, [selectedBrands]);

  const handleBrandCheckChange = (event) => {
    setBrandChecked(event.target.checked);
    if (event.target.checked) {
      const selBrands = selectedBrands || [];
      brandsChangeCallback(selBrands, brands._id, brands.name);
    } else {
      setSelectedBrands(null);
      brandsChangeCallback(null, brands._id, brands.name);
    }
  };

  const handleBrandChange = (selectedOption) => {
    setSelectedBrands(selectedOption);
  };

  return (
    <div className="questionnaire-column">
      <div className={`questionnaire-column-card ${brandChecked ? 'active' : ''}`}>
        <span className="checkmark" />
        <div className="questionnaire-column-card-head">
          <h3>
            <img
              src={icon}
              alt={heading}
            />
            {heading}
          </h3>
          <p>{tagLine}</p>
          <label htmlFor={brands && brands.name} className="input-container">
            <input
              type="checkbox"
              name={brands && brands.name}
              id={brands && brands.name}
              checked={brandChecked}
              onChange={handleBrandCheckChange}
            />
            <span className="checkmark" />
          </label>
        </div>
        <div className="questionnaire-column-card-row">
          { brands && (
          <FormGroup>
            <div>
              <SubCategorySelect
                brands={brands}
                selectedBrands={selectedBrands}
                handleBrandChange={handleBrandChange}
                isCreatable={brands.name === 'Other'}
              />
            </div>
          </FormGroup>
          )}

        </div>
      </div>
    </div>
  );
}

QuestionnaireCard.propTypes = {
  icon: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  tagLine: PropTypes.string.isRequired,
  brands: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
  }),
  intrests: PropTypes.array,
  brandsChangeCallback: PropTypes.func.isRequired,
};

QuestionnaireCard.defaultProps = {
  brands: null,
  intrests: null,
};

export default React.memo(QuestionnaireCard);
